/* eslint-disable */
"use strict";

document.addEventListener("DOMContentLoaded", () => {
    const customScrollContainers = document.querySelectorAll("[custom-scroll]");

    window.OD = window.OD || {};

    window.OD.checkScrollVisibility = function (container) {
        setTimeout(() => {
            const content = container.querySelector("[custom-scroll-content]");
            const scrollbar = container.querySelector("[custom-scrollbar]");

            const contentHeight = content.scrollHeight;
            const containerHeight = container.clientHeight;

            if (contentHeight > containerHeight) {
                scrollbar.classList.add("show");
            } else {
                scrollbar.classList.remove("show");
            }
        }, 300);
    };

    if (customScrollContainers.length > 0) {
        const updateThumbPosition = (container, content, scrollbar, thumb) => {
            const contentHeight = content.scrollHeight;
            const containerHeight = container.clientHeight;
            const scrollTop = content.scrollTop;

            const thumbHeight = Math.max(
                (containerHeight / contentHeight) * containerHeight,
                20
            );
            thumb.style.height = `${thumbHeight}px`;

            let thumbTop = (scrollTop / contentHeight) * containerHeight;

            const maxThumbTop = scrollbar.clientHeight - thumbHeight - 6;
            thumbTop = Math.min(Math.max(thumbTop, 0), maxThumbTop);

            thumb.style.transform = `translateY(${thumbTop}px)`;
        };

        customScrollContainers.forEach((container) => {
            const content = container.querySelector("[custom-scroll-content]");
            const scrollbar = container.querySelector("[custom-scrollbar]");
            const thumb = container.querySelector("[custom-scrollbar-thumb]");

            if (!content || !thumb) return;

            content.addEventListener("scroll", () =>
                updateThumbPosition(container, content, scrollbar, thumb)
            );
            window.addEventListener("resize", () =>
                updateThumbPosition(container, content, scrollbar, thumb)
            );

            let isDragging = false;
            let startY;
            let startScrollTop;

            thumb.addEventListener("mousedown", (e) => {
                isDragging = true;
                startY = e.clientY;
                startScrollTop = content.scrollTop;
                document.body.classList.add("no-select");
            });

            document.addEventListener("mousemove", (e) => {
                if (isDragging) {
                    const deltaY = e.clientY - startY;
                    const contentHeight = content.scrollHeight;
                    const containerHeight = container.clientHeight;

                    const scrollDelta =
                        (deltaY / containerHeight) * contentHeight;
                    content.scrollTop = startScrollTop + scrollDelta;
                }
            });

            document.addEventListener("mouseup", () => {
                isDragging = false;
                document.body.classList.remove("no-select");
            });

            updateThumbPosition(container, content, scrollbar, thumb);

            window.OD.checkScrollVisibility(container);
        });
    }
});
